import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <header className="header">
      <h1 className="subtitle">WaNT tO haer A dAD JoKE?</h1>
      <p className="subtitle">mE toO!</p>
    </header>
    
  );
};

export default Header;

